import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useController } from 'react-hook-form'
import { CameraDropIcon } from '../../helper/imagepath'
import FilePreview from './filePreview'
import { uniqueId } from '../../helper/function'

const DropzoneController = ({
  name,
  maxFiles = 1,
  acceptExtensions,
  control,
  isSingleUpload = false,
  files = [],
  isEditImage = false,
  module,
  isAddMode = false,
  ...rest
}) => {
  const {
    field: { onChange },
    formState: { errors }
  } = useController({
    name,
    control,
    defaultValue: []
  })

  const [fileUpload, setFileUpload] = useState([])
  const [images, setImages] = useState(files)
  const [imageKey, setImageKey] = useState('')

  useEffect(() => {
    if (isSingleUpload) {
      setFileUpload([])
    }
  }, [])

  const onDrop = (acceptedFiles) => {
    // const newFiles = acceptedFiles.filter((file) => file.size < 2000000)
    // if (newFiles.length !== acceptedFiles.length) {
    //   errorToast('One or more files exceed the 2MB size limit. Please ensure all files are under 2MB')
    //   return
    // }
    const mappedFiles = acceptedFiles.map((file) => ({
      uuid: uniqueId(),
      file,
      uploadProgress: 0 // Initialize progress at 0%
    }))
    if (isSingleUpload) {
      setFileUpload(mappedFiles)
    } else {
      if (fileUpload?.length) {
        setFileUpload((prev) => [...prev, ...mappedFiles])
      } else {
        setFileUpload(mappedFiles)
      }
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptExtensions,
    multiple: maxFiles > 1 || false,
    maxFiles,
    ...rest
  })

  useEffect(() => {
    if (isSingleUpload) {
      setImages([imageKey])
    } else if (imageKey) {
      setImages((prev) => [...prev, imageKey])
    }
  }, [imageKey])

  useEffect(() => {
    onChange(images)
  }, [images])

  const onProgressChange = (fileUuid, progress) => {
    setFileUpload((prev) => prev.map((file) => (file.uuid === fileUuid ? { ...file, uploadProgress: progress } : file)))
  }

  // Remove file from upload list
  const removeFile = (fileUuid) => {
    const updatedFiles = fileUpload.filter((file) => file.uuid !== fileUuid)
    setFileUpload([...updatedFiles])
  }

  useEffect(() => {
    if (isEditImage) {
      const editImages = files.map((url) => ({
        uuid: uniqueId(), // Generates a unique ID for each entry
        url: url
      }))
      setFileUpload(editImages)
    }
  }, [files])

  const filesPreview = (
    <>
      {fileUpload?.map((fileData) => (
        <FilePreview
          key={fileData?.uuid}
          file={fileData?.file}
          propertyImages={files}
          fileUuid={fileData?.uuid}
          imageURL={fileData?.url}
          filesUrlList={files}
          setImageKey={setImageKey}
          onRemove={(fileUuid) => removeFile(fileUuid, false)}
          setImages={setImages}
          onChange={onChange}
          onProgressChange={onProgressChange} // Pass the onProgressChange function
          progress={fileData?.uploadProgress}
          module={module}
          isAddMode={isAddMode}
        />
      ))}
    </>
  )

  return (
    <>
      <div {...getRootProps()} className="service-upload">
        <input {...getInputProps()} />
        <span>
          <img src={CameraDropIcon} alt="upload" width={80} />
        </span>
        <h6 className="drop-browse align-center">{isDragActive ? 'Drop the files here ...' : 'Drag & drop images here, or click to upload'}</h6>
      </div>
      {errors?.property_image?.length > 0 && <p className="text-danger error">{errors.property_image.map((error) => error?.message)}</p>}
      {name == 'cleaning_images' && errors?.cleaning_images?.message && <span className="text-danger">{errors.cleaning_images?.message}</span>}
      {/* {name === 'images' && errors?.images?.message && <span className="text-danger">{errors.images?.message}</span>} */}
      <div className="mt-2">{filesPreview}</div>
    </>
  )
}

export default DropzoneController
